module.exports = __webpack_public_path__ + "fonts/SFProText-Bold.8e175b47.woff2";